
import { Dialog } from "element-ui"

export default {
  components: {
    [Dialog.name]: Dialog
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      curVisible: false
    }
  },
  watch: {
    visible: {
      handler(newVal) {
        this.curVisible = newVal
      },
      immediate: true
    }
  },
  methods: {
    handleClose() {
      this.$emit("close")
      this.$bus.$emit("onRefreshOrderList")
    }
  }
}
